<template>
  <div>
    <Head :title="__('Classes')" />
    <div class="flex items-center justify-between mb-6">
      <div class="flex items-center w-full max-w-2xl mr-4">
        <search-input v-model="form.search" class="w-full max-w-md mr-4" @reset="reset"></search-input>
        <select v-model="form.campus" class="form-select">
          <option :value="null">{{ __('All Campuses') }}</option>
          <option v-for="c in campusOptions" :key="c.value" :value="c.value">{{ c.label }}</option>
        </select>
      </div>
      <Link class="btn-indigo" :href="route('classes.create')">
        <span>{{ __('Create New') }}</span>
      </Link>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">{{ __('Name') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Description') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Status') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Created') }}</th>
            <th class="px-6 pt-6 pb-4"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="classItem in classes.data" :key="classItem.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="route('classes.edit', classItem.id)">
                {{ classItem.name }}
                <icon v-if="classItem.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 ml-2 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="route('classes.edit', classItem.id)" tabindex="-1">
                {{ classItem.description || '-' }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="route('classes.edit', classItem.id)" tabindex="-1">
                <span :class="classItem.status ? 'text-green-600' : 'text-red-600'">
                  {{ classItem.status ? __('Active') : __('Inactive') }}
                </span>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="route('classes.edit', classItem.id)" tabindex="-1">
                {{ classItem.created_at }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="route('classes.edit', classItem.id)" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="classes.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="5">{{ __('No classes found.') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="classes.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'

export default {
  components: {
    SearchInput,
    Head,
    Icon,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    classes: Object,
    campusOptions: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        campus: this.filters.campus || null,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(this.route('classes.index'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
